module.exports = __webpack_public_path__ + "files/a1ba784c55e14c18aaa16b1d6357ca06.png";


//////////////////
// WEBPACK FOOTER
// ./images/emoji-sheets/symbols-1.png
// module id = 527
// module chunks = 76